import { ruleDefinitionDefaults, defaultValidationMetafieldRule, createValidator, createClashingRulesValidationFunctionNew } from './TagRulesCommon'

const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "UpdateProductMetafieldFromVariantOption",
    title: "Update Product Metafield From Variant Options",
    description: "Automatically set a product metafield based on a preselected variant option.",
    example: "Selecting the Size option for a clothing item will add the first corresponding Size value to the specified product metafield",
    additional: [
        "Products/variants that do not have the selected option will not be affected.",
        "If product has multiple variants, only the first one will be used.",
        "Products with more that one variant can be ignored by using the filter section below.",
    ],
    legacy: false,
    inProgress: false,
    previewType: "ProductMetafield",
    tags: ["Products", "Variants", "Metafields"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "UpdateProductMetafieldFromVariantOption",
                metafieldType: "single_line_text_field",
                metafieldNamespaceAndKey: null,
                optionName: null,
                skipProductsWithMultipleVariants: false,
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationMetafieldRule,
                (rule, errors) => {
                    if (rule.settings.optionName == null || rule.settings.optionName === "") {
                        errors["optionName"] = "Option name is required";
                    }
                },],
            createClashingRulesValidationFunctionNew("PRODUCT"));
    }
};

export default ruleDefinition;